
export let environment = {
    window:{
        size: "",
        width: 0,
        height: 0,
        orientation: ""
    },
    browser:{
        name: "",
        version: 0,
    },
    os:{
        name: "",
        version: 0,
    },
    userAgent: window.navigator.userAgent,
    device: window.navigator.platform,
    isDevice: false
};

export const os = [
    { name: 'Windows Phone', value: 'Windows Phone', version: 'OS' },
    { name: 'Windows', value: 'Win', version: 'NT' },
    { name: 'iPhone', value: 'iPhone', version: 'OS' },
    { name: 'iPad', value: 'iPad', version: 'OS' },
    { name: 'Kindle', value: 'Silk', version: 'Silk' },
    { name: 'Android', value: 'Android', version: 'Android' },
    { name: 'PlayBook', value: 'PlayBook', version: 'OS' },
    { name: 'BlackBerry', value: 'BlackBerry', version: '/' },
    { name: 'Macintosh', value: 'Mac', version: 'OS X' },
    { name: 'Linux', value: 'Linux', version: 'rv' },
    { name: 'Palm', value: 'Palm', version: 'PalmOS' }
];

export const browser = [
    { name: 'Chrome', value: 'Chrome', version: 'Chrome' },
    { name: 'Firefox', value: 'Firefox', version: 'Firefox' },
    { name: 'Safari', value: 'Safari', version: 'Version' },
    { name: 'Internet Explorer', value: 'MSIE', version: 'MSIE' },
    { name: 'Internet Explorer', value: 'Trident/', version: 'Trident/' },
    { name: 'Opera', value: 'Opera', version: 'Opera' },
    { name: 'Mozilla', value: 'Mozilla', version: 'Mozilla' },
    { name: 'BlackBerry', value: 'CLDC', version: 'CLDC' }
];

export const header = [
    window.navigator.platform,
    window.navigator.userAgent,
    window.navigator.appVersion,
    window.navigator.vendor,
    window.opera
];


/** WEBPACK FOOTER **
 ** ./src/models/environmentModels.js
 **/